import * as React from 'react'
import {ReactElement} from 'react'
import {Nullable} from '../../../../../app/TypeHelpers'
import {
    createErrorHandlingForm,
    ErrorHandlingFormProps,
} from '../../../../../components/shared/forms/hoc/createErrorHandlingForm'
import {EnterKeyHandlerProps, withEnterKeyHandler} from '../../../../../components/shared/forms/hoc/withEnterKeyHandler'
import equal from 'fast-deep-equal'
import {formatForDateInputFromDate} from '../../../../../formatters/formatDate'
import {OutlinedInput} from '@mui/material'

interface State {
    value: Nullable<Date>
}

interface Props {
    onChangeDate: (date: Nullable<Date>) => void
    onChange?: (event: any, checked?: boolean) => void
    value: Nullable<Date>
    maxDate?: Nullable<Date>
    minDate?: Nullable<Date>
}

class OutlinedDatePicker
    extends React.Component<Props & ErrorHandlingFormProps & EnterKeyHandlerProps, State> {

    constructor(props: Props & ErrorHandlingFormProps & EnterKeyHandlerProps) {
        super(props)
        this.state = {
            value: new Date(),
        }
    }

    componentDidMount(): void {
        if (this.props.value && this.props.value.toString() === 'Invalid Date') {
            this.setState({value: null})
        } else {
            this.setState({value: this.props.value})
        }
    }

    componentDidUpdate(
        prevProps: Readonly<Props & ErrorHandlingFormProps & EnterKeyHandlerProps>, prevState: Readonly<State>,
    ): void {
        if (!equal(prevProps, this.props)) {
            if (this.props.value && this.props.value.toString() === 'Invalid Date') {
                this.setState({value: null})
            } else {
                this.setState({value: this.props.value})
            }
        }
    }

    handleDateChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const dateString: Nullable<string> = event.target.value
        let date: Nullable<Date> = null

        if (dateString) {
            date = new Date(dateString)
            if (date.toString() === 'Invalid Date') {
                date = null
            }
        }

        this.setState({
            value: date,
        }, () => {
            this.props.onChangeDate(date)
            if (this.props.onChange) {
                this.props.onChange(null)
            }
            setTimeout(() => {
                event.target.defaultValue = ''
            })
        })
    }

    handleDateFocusM = (event: React.FocusEvent<HTMLInputElement>): void => {
        setTimeout(() => {
            event.target.defaultValue = ''
        })
    }

    formatDateOrDefault<T>(date: Date | null | undefined, defaultValue: T): string | T {
        if (!date) {
            return defaultValue
        }
        return formatForDateInputFromDate(date)
    }

    render(): ReactElement {

        return <OutlinedInput
            inputProps={{
                min: this.formatDateOrDefault(this.props.minDate, undefined),
                max: this.formatDateOrDefault(this.props.maxDate, undefined),
            }}
            type={'date'}
            onChange={this.handleDateChange}
            onFocus={this.handleDateFocusM}
            value={this.formatDateOrDefault(this.state.value, '')}
            fullWidth
        />
    }
}

export default createErrorHandlingForm(withEnterKeyHandler(OutlinedDatePicker))
